import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useContactType(userId) {
  const { data, mutate } = useSWR(
    userId ? `/contacttypes/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    contactType: data,
    mutate: mutate,
  };
}

export default useContactType;
